import React from 'react';
import { PropTypes } from 'prop-types';

import OneHourAfterJapBroadcast from 'app/features/newLanding/components/HeroBlock/Perks/OneHourAfterJapBroadcast';
import AdFreeAnime from 'app/features/newLanding/components/HeroBlock/Perks/AdFreeAnime';
import OfflineViewing from 'app/features/newLanding/components/HeroBlock/Perks/OfflineViewing';
import StoreDiscounts from 'app/features/newLanding/components/HeroBlock/Perks/StoreDiscounts';
import StreamOnDevices from 'app/features/newLanding/components/HeroBlock/Perks/StreamOnDevices';
import connect from 'app/libs/connect';
import { userCountryCode } from 'app/features/user/selectors';

const UI = ({ userCountryCode }) => (
  <>
    <AdFreeAnime />
    <OneHourAfterJapBroadcast />
    <OfflineViewing />
    {userCountryCode === 'US' ? <StoreDiscounts /> : <StreamOnDevices />}
  </>
);

UI.propTypes = { userCountryCode: PropTypes.string.isRequired };

const Perks = connect({ userCountryCode })(UI);

export { UI };

export default Perks;
